import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { ToolState } from './state';

const defaultState: ToolState = {
  tools: [],
};

export const toolModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
